<template>
  <div class="register-container">
    <!-- 顶部导航栏 -->
    <header class="register-header">
      <div class="header-content">
        <div class="logo">
          <span class="logo-text">TaskLink</span>
        </div>
      </div>
    </header>

    <!-- 注册表单区域 -->
    <main class="register-main">
      <div class="register-box">
        <div class="register-title-section">
          <h1 class="register-title">账号注册</h1>
          <div class="login-link">
            已有账号，<a href="#" class="link-text" @click.prevent="$emit('go-home')">去登录</a>
          </div>
        </div>

        <form class="register-form" @submit.prevent="handleRegister">
          <!-- 名称 -->
          <div class="form-group">
            <label class="form-label">名称</label>
            <div class="input-wrapper">
              <span class="input-icon">👤</span>
              <input 
                type="text" 
                class="form-input" 
                placeholder="请输入名称"
                v-model="formData.name"
              >
            </div>
          </div>

          <!-- 手机号/邮箱 -->
          <div class="form-group">
            <label class="form-label">手机号/邮箱</label>
            <div class="input-wrapper">
              <span class="input-icon">📱</span>
              <input 
                type="text" 
                class="form-input" 
                placeholder="请输入手机号/邮箱进行验证"
                v-model="formData.contact"
              >
            </div>
          </div>

          <!-- 验证码 -->
          <div class="form-group">
            <label class="form-label">验证码</label>
            <div class="input-wrapper verification-wrapper">
              <input 
                type="text" 
                class="form-input verification-input" 
                placeholder="验证码"
                v-model="formData.code"
              >
              <button type="button" class="verify-btn" @click="sendCode">
                {{ codeText }}
              </button>
            </div>
          </div>

          <!-- 密码 -->
          <div class="form-group">
            <label class="form-label">密码</label>
            <div class="input-wrapper">
              <span class="input-icon">🔒</span>
              <input 
                :type="showPassword ? 'text' : 'password'" 
                class="form-input" 
                placeholder="请输入密码"
                v-model="formData.password"
              >
              <span class="toggle-password" @click="showPassword = !showPassword">
                {{ showPassword ? '👁️' : '👁️‍🗨️' }}
              </span>
            </div>
          </div>

          <!-- 确认密码 -->
          <div class="form-group">
            <label class="form-label">确认密码</label>
            <div class="input-wrapper">
              <span class="input-icon">🔒</span>
              <input 
                :type="showConfirmPassword ? 'text' : 'password'" 
                class="form-input" 
                placeholder="请再次输入密码"
                v-model="formData.confirmPassword"
              >
              <span class="toggle-password" @click="showConfirmPassword = !showConfirmPassword">
                {{ showConfirmPassword ? '👁️' : '👁️‍🗨️' }}
              </span>
            </div>
          </div>

          <!-- 注册按钮 -->
          <button type="submit" class="register-button">
            登 录
          </button>

          <!-- 协议 -->
          <div class="agreement">
            <input type="checkbox" id="agreement" v-model="agreed" class="agreement-checkbox">
            <label for="agreement" class="agreement-text">
              我已阅读并同意 <a href="#" class="agreement-link">《用户协议》</a> 和 <a href="#" class="agreement-link">《隐私协议》</a>
            </label>
          </div>
        </form>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  name: 'RegisterPage',
  data() {
    return {
      formData: {
        name: '',
        contact: '',
        code: '',
        password: '',
        confirmPassword: ''
      },
      showPassword: false,
      showConfirmPassword: false,
      agreed: false,
      codeText: '获取验证码',
      countdown: 60
    }
  },
  methods: {
    handleRegister() {
      if (!this.agreed) {
        alert('请先阅读并同意用户协议和隐私协议')
        return
      }
      
      if (!this.formData.name) {
        alert('请输入名称')
        return
      }
      
      if (!this.formData.contact) {
        alert('请输入手机号或邮箱')
        return
      }
      
      if (!this.formData.code) {
        alert('请输入验证码')
        return
      }
      
      if (!this.formData.password) {
        alert('请输入密码')
        return
      }
      
      if (this.formData.password !== this.formData.confirmPassword) {
        alert('两次输入的密码不一致')
        return
      }
      
      console.log('注册信息：', this.formData)
      alert('注册成功！')
    },
    
    sendCode() {
      if (!this.formData.contact) {
        alert('请先输入手机号或邮箱')
        return
      }
      
      if (this.countdown < 60) {
        return
      }
      
      // 模拟发送验证码
      console.log('发送验证码到：', this.formData.contact)
      
      // 开始倒计时
      this.countdown = 60
      this.codeText = `${this.countdown}s后重新获取`
      
      const timer = setInterval(() => {
        this.countdown--
        if (this.countdown > 0) {
          this.codeText = `${this.countdown}s后重新获取`
        } else {
          this.codeText = '获取验证码'
          clearInterval(timer)
        }
      }, 1000)
    }
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.register-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #e8ecf1 100%);
  display: flex;
  flex-direction: column;
}

/* 顶部导航栏 */
.register-header {
  width: 100%;
  max-width: 1920px;
  height: 120px;
  background: rgba(255, 255, 255, 0.6);
  border-radius: 0px 0px 0px 0px;
  border: 1px solid rgba(0, 0, 0, 0.09);
  backdrop-filter: blur(10px);
  margin: 0 auto;
  display: flex;
  align-items: center;
  padding: 0 80px;
}

.header-content {
  width: 100%;
  display: flex;
  align-items: center;
}

.logo {
  display: flex;
  align-items: center;
}

.logo-text {
  font-family: 'Georgia', serif;
  font-size: 32px;
  font-weight: 700;
  color: #1a1a1a;
  letter-spacing: 1px;
}

/* 主要内容区 */
.register-main {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 60px 20px;
}

.register-box {
  width: 100%;
  max-width: 580px;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 24px;
  padding: 50px 60px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.08);
  backdrop-filter: blur(20px);
}

.register-title-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 40px;
}

.register-title {
  font-size: 32px;
  font-weight: 700;
  color: #1a1a1a;
  letter-spacing: 1px;
}

.login-link {
  font-size: 14px;
  color: #666;
}

.link-text {
  color: #5CB85C;
  text-decoration: none;
  font-weight: 600;
  transition: color 0.3s;
}

.link-text:hover {
  color: #4CAF50;
}

/* 表单样式 */
.register-form {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.form-label {
  font-size: 15px;
  font-weight: 600;
  color: #333;
}

.input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  background: #f8f9fa;
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  padding: 0 16px;
  transition: all 0.3s;
}

.input-wrapper:focus-within {
  background: white;
  border-color: #5CB85C;
  box-shadow: 0 0 0 3px rgba(92, 184, 92, 0.1);
}

.input-icon {
  font-size: 18px;
  margin-right: 12px;
  opacity: 0.6;
}

.form-input {
  flex: 1;
  border: none;
  background: transparent;
  padding: 16px 0;
  font-size: 15px;
  color: #333;
  outline: none;
}

.form-input::placeholder {
  color: #999;
}

.toggle-password {
  font-size: 18px;
  cursor: pointer;
  opacity: 0.6;
  transition: opacity 0.3s;
  user-select: none;
}

.toggle-password:hover {
  opacity: 1;
}

/* 验证码输入框 */
.verification-wrapper {
  padding: 0;
}

.verification-input {
  padding: 16px;
  border-right: 1px solid #e0e0e0;
}

.verify-btn {
  flex-shrink: 0;
  padding: 16px 20px;
  background: transparent;
  border: none;
  color: #5CB85C;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
  white-space: nowrap;
}

.verify-btn:hover {
  color: #4CAF50;
}

.verify-btn:active {
  transform: scale(0.98);
}

/* 注册按钮 */
.register-button {
  width: 100%;
  padding: 18px;
  background: linear-gradient(135deg, #5CB85C 0%, #4CAF50 100%);
  border: none;
  border-radius: 12px;
  color: white;
  font-size: 18px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s;
  margin-top: 12px;
  box-shadow: 0 8px 20px rgba(92, 184, 92, 0.3);
}

.register-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 28px rgba(92, 184, 92, 0.4);
}

.register-button:active {
  transform: translateY(0);
}

/* 协议 */
.agreement {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
}

.agreement-checkbox {
  width: 16px;
  height: 16px;
  cursor: pointer;
  accent-color: #5CB85C;
}

.agreement-text {
  font-size: 13px;
  color: #666;
  cursor: pointer;
}

.agreement-link {
  color: #5CB85C;
  text-decoration: none;
  font-weight: 600;
}

.agreement-link:hover {
  text-decoration: underline;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .register-header {
    height: 80px;
    padding: 0 30px;
  }

  .logo-text {
    font-size: 24px;
  }

  .register-box {
    padding: 40px 30px;
  }

  .register-title {
    font-size: 26px;
  }

  .register-main {
    padding: 40px 20px;
  }
}

@media (max-width: 480px) {
  .register-header {
    padding: 0 20px;
  }

  .register-box {
    padding: 30px 20px;
  }

  .register-title-section {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .form-input {
    font-size: 14px;
  }
}
</style>

